/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Permission_Name_Usercustompages_WriteInputs */

const en_enum_permission_name_usercustompages_write = /** @type {(inputs: Enum_Permission_Name_Usercustompages_WriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usercustompages Write`)
};

const de_enum_permission_name_usercustompages_write = /** @type {(inputs: Enum_Permission_Name_Usercustompages_WriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usercustompages Write`)
};

/**
* | output |
* | --- |
* | "Usercustompages Write" |
*
* @param {Enum_Permission_Name_Usercustompages_WriteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_permission_name_usercustompages_write = /** @type {((inputs?: Enum_Permission_Name_Usercustompages_WriteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Permission_Name_Usercustompages_WriteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_permission_name_usercustompages_write(inputs)
	return de_enum_permission_name_usercustompages_write(inputs)
});